export default "/_next/static/mentor-events.svg";